export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "m12 13.4139 4.9497 4.9498 1.4142-1.4142-4.9497-4.9498L18.3639 7.05l-1.4142-1.4143L12 10.5855 7.0502 5.6357 5.636 7.05l4.9497 4.9497-4.9497 4.9498 1.4142 1.4142L12 13.4139z" } }];
export const iconName = 'cross';
export const cross = { iconName, paths };
export default paths;
